/**
 * This file is generated from 'npm run build-svg'. Any changes should be made to the
 * template in .svgrrc.js or to the source SVG in src/icons/svg.
 **/
import React from "react";
export const SvgPlay: React.FC<React.SVGAttributes<SVGElement>> = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <g fill="none" fillRule="evenodd">
            <path
                fill="currentColor"
                d="M18.023 12.933l-9.857 6.878a1.042 1.042 0 01-1.486-.31 1.166 1.166 0 01-.18-.623V5.122C6.5 4.502 6.98 4 7.572 4c.211 0 .418.066.594.188l9.857 6.879c.492.343.625 1.04.297 1.555-.079.123-.18.23-.297.311z"
            />
            <path d="M0 0h24v24H0z" />
        </g>
    </svg>
);
